<template lang="pug">
  transition(name="fade" mode="out-in")
    .overall
      .header
        slot(name="header")
      .content
        slot(name="content")
</template>
<script>

export default {
  destroy() {
    this.onDestroy()
  },
  methods: {
    onDestroy() {
      this.$el.remove();
    },
  },
};
</script>
<style lang="scss">
  .overall{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    z-index: 10;
    background-color: black;
    .modal-header{
      position: absolute;
      top: 0;
      right: 10px;
      z-index: 11;
      .button{
        margin: 10px 0;
        opacity: 0.6;
        transition: opacity 0.3s;
        &:hover,
        &:focus,
        &:active{
          opacity: 1;
        }
      }
    }
    .content{
      /deep/ section{
        .iframewrapper{
          height: 100vh;
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }

</style>
